const isDev = location.href.includes('.dev');

export const environment = {
  production: true,
  proUrl: isDev ? 'https://pro.evinature.dev' : 'https://pro.evinature.com',
  // evidata-api — serves the PRO-driven quiz; its Redis holds the CMS tables
  // and built PROs the Redis Explorer inspects.
  apiUrl: isDev ? 'https://api.evinature.dev' : 'https://api.evinature.com',
  client_id: '529714753402-4qi6se2533nuabibqt3mu1dro630e5m4.apps.googleusercontent.com',
  rechargeHookApiKey: '513e36d1244a174c3ccefe25093b779288d4ccf7919ecff6854a60cbe2fdd2d3',
};
